import moment from 'moment';
export default function toMoment(date) {
    return date ? moment(date).utc() : undefined;
}
//# sourceMappingURL=to-moment.js.map